import { render } from "./UserEditForm.vue?vue&type=template&id=5a7b1a93&scoped=true"
import script from "./UserEditForm.vue?vue&type=script&lang=js"
export * from "./UserEditForm.vue?vue&type=script&lang=js"

import "./UserEditForm.vue?vue&type=style&index=0&id=5a7b1a93&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7b1a93"]])

export default __exports__